import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { DatosFechas } from '../models/datos-Fechas';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/DatosFechas';

@Injectable({
  providedIn: 'root'
})
export class DatosFechasService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getByPersonal(id: number, agrupar: boolean): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + id + '/' + agrupar })
  }

  getHistoryByClase(personalId: number, clase: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetHistoryByClase/' + personalId + '/' + clase });
  }

  guardar(data, cortarRegistro): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/Save/' + cortarRegistro, body: data, cacheMins: 0 });
  }

  eliminar(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }

  getFormatoImportacion() {
    const formato = [
      { personal: 0,
        desde: '00/00/0000',
        hasta: '00/00/0000',
        claseFecha: '', 
        fechaEvento: '00/00/0000',
        errores: ['No Completar']}
    ];

    //claseFecha se deben validar que existan

    return formato;
  }

  
}

